import axios from "../../config/axiosConfig";
import { DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST, DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, GET_DELIVERY_CHALLAN_RETURN_TRANSACTIONS_AVAILABLE_TAKA_NO,
  GET_DELIVERY_CHALLAN_RETURN_AVAILABLE_TRANSACTIONS } from "../types";

export const getDeliveryChallanReturnAvailableTransactions = (queryParams) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { ...queryParams, finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      // Construct query string for cURL
      // const queryString = new URLSearchParams(params).toString();
      // const curlCommand = `curl -X GET "http://localhost:4000/delivery-challan-return-available-transaction/getAllDeliChallanReturnAvailableTransactions?${queryString}"`;

      // console.log("cURL Request:\n", curlCommand); 
      return axios.get("/delivery-challan-return-available-transaction/getAllDeliChallanReturnAvailableTransactions", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_RETURN_AVAILABLE_TRANSACTIONS, payload: response.data });
        }
        return response.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getDeliveryChallanReturnAvailableTransactionTakaNo = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Company) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/delivery-challan-return-available-transaction/getAllDeliChallanReturnAvailableTransactions", { params }).then((response) => {
        const takaNos = response.data.map((data) => data.Taka_No);
        if (response.data) {
          dispatch({ type: GET_DELIVERY_CHALLAN_RETURN_TRANSACTIONS_AVAILABLE_TAKA_NO, payload: takaNos });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DELIVERY_CHALLAN_RETURN_TRANSACTION_AVAILABLE_REQUEST_FAILURE, error: error.message });
    }
  };
};

